// Pac-Man progress bar: munches across a row of $ signs while a screen loads.
export default function PacManBar({ label, className = "py-10", testid = "pacman-bar" }) {
  return (
    <div className={`flex w-full flex-col items-center justify-center gap-2 ${className}`} role="status" aria-label={label || "Loading"} data-testid={testid}>
      <div className="pmb-track" aria-hidden="true">
        <div className="pmb-dots">{Array.from({ length: 9 }, (_, i) => <span key={i}>$</span>)}</div>
        <div className="pmb-fill" />
        <span className="pmb-man pm-wrap" style={{ "--pm": "18px" }}><span className="pm-jaw pm-top" /><span className="pm-jaw pm-bottom" /></span>
      </div>
      {label && <p className="text-xs text-slate-500">{label}</p>}
    </div>
  );
}
